/**
 * @fileOverview This file contains the implementation of the hook to manage the tour/tutorial in Assets module.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Typography } from "@mui/material";
import { useTranslationHook } from "../hooks/UseTranslationHook";

const useAssetsTour = (setModalAShow) => {
  const {
    assetsS1P1,
    assetsS1P2,
    assetsS2P1,
    assetsS2P2,
    assetsS3P1,
    assetsS3P2,
    assetsS3P3,
    assetsS3P4,
    assetsS3P5,
    assetsS4P1,
    assetsS4P2,
    assetsS5P1,
    assetsS5P2,
  } = useTranslationHook();

  return [
    {
      selector: ".create-asset-tour",
      content: (
        <Typography>
          <strong>{assetsS1P1}</strong> {assetsS1P2}
        </Typography>
      ),
      action: () => setModalAShow(false),
      stepInteraction: false,
    },
    {
      content: (
        <Typography>
          {assetsS2P1} <strong>{assetsS2P2}</strong>.
        </Typography>
      ),
      action: () => setModalAShow(true),
      stepInteraction: false,
    },
    {
      selector: ".create-asset-form-tour",
      content: (
        <Typography>
          {assetsS3P1} <strong>{assetsS3P2}</strong>. {assetsS3P3}{" "}
          <strong>{assetsS3P4}</strong> {assetsS3P5}
        </Typography>
      ),
      action: () => setModalAShow(true),
      stepInteraction: false,
    },
    {
      selector: ".assets-datagrid-tour",
      content: (
        <Typography>
          {assetsS4P1} <strong>{assetsS4P2}</strong>.
        </Typography>
      ),
      action: () => setModalAShow(false),
      stepInteraction: false,
    },
    {
      selector: ".assets-datagrid-actions-tour",
      content: (
        <Typography>
          {assetsS5P1} <strong>{assetsS5P2}</strong>.
        </Typography>
      ),
      action: () => setModalAShow(false),
      stepInteraction: false,
    },
  ];
};

export default useAssetsTour;
